
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexHvRRbCYdkLKmjq3L_453FIgyHHrPlX5lzkvLgfdiSEemEMeta } from "/app/pages/a/index.vue?macro=true";
import { default as indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta } from "/app/pages/news/index.vue?macro=true";
import { default as _91slug_93OY1eKGH50IeGHXpXb3BdZRgtgqHXLtURcDbb48n4NVYMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as indexYgfmGqtGumcIIWnPQ2lzmh3E8xIT9ykCcGyS3clwjRIMeta } from "/app/pages/confidential/index.vue?macro=true";
import { default as index4P4qVwFByCIjnorORJ4p_ZTWP0ZD3jxzabpV3d5B1ygMeta } from "/app/pages/terms_of_use/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "a",
    path: "/a",
    meta: indexHvRRbCYdkLKmjq3L_453FIgyHHrPlX5lzkvLgfdiSEemEMeta || {},
    component: () => import("/app/pages/a/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "confidential",
    path: "/confidential",
    component: () => import("/app/pages/confidential/index.vue")
  },
  {
    name: "terms_of_use",
    path: "/terms_of_use",
    component: () => import("/app/pages/terms_of_use/index.vue")
  }
]